import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withStyles, Grid } from '@material-ui/core';
import { UserCard, FHEContainer, FHEContainerScroll, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgSecurity } from 'data/common/iconsvg';

import { getSecurityDetails, switchSecurityMaster, dissociateSecurityUser, dissociateSecurityUserAndSwitchMaster } from '../../data/Security/actions';

class SecurityDetail extends Component {
    static propTypes = {
        getSecurityDetails: PropTypes.func.isRequired,
        dissociateSecurityUser: PropTypes.func.isRequired,
        dissociateSecurityUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSecurityMaster: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        classes: PropTypes.object.isRequired,
        Security: PropTypes.object,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        Security: new Map()
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false
        };
    }

    componentDidMount() {
        this.getSecurityDetails();
    }

    getSecurityDetails = () => {
        const { getSecurityDetails, match } = this.props;

        this.setState({ loading: true, error: null });
        getSecurityDetails(match.params.securityId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSecurityMaster = (SecurityMac, userId) => {
        const { switchSecurityMaster } = this.props;

        return switchSecurityMaster(SecurityMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSecurityUser = (SecurityMac, userId) => {
        const { dissociateSecurityUser } = this.props;

        return dissociateSecurityUser(SecurityMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSecurityUserAndSwitchMaster = (SecurityMac, userId, masterId) => {
        const { dissociateSecurityUserAndSwitchMaster } = this.props;

        return dissociateSecurityUserAndSwitchMaster(SecurityMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    renderUserList() {
        const { usersLoading, actionDisabled } = this.state;
        const { Security, profile } = this.props;
        const users = [];

        if (!usersLoading && Security.has('otherUsers')) {
            Security.get('otherUsers').map(user => {
                const isMaster = Security.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    Security.get('otherUsers').map(user => {
                        if (user.get('_id') !== Security.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={Security}
                            productName="security"
                            environment="myfhe"
                            dissociateUserFunc={this.dissociateSecurityUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSecurityUserAndSwitchMaster}
                            switchMasterFunc={this.switchSecurityMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }

    renderLastConnection = lastConnection => {
        const { classes } = this.props;
        if (lastConnection) {
            return moment(lastConnection).format('DD/MM/YYYY HH:MM:ss');
        } else {
            return <span className={classes.noConnection}>{Translator.translate('general.noConnection')}</span>;
        }
    };

    renderPartDetail = () => {
        const { Security } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.batteryLevel')} itemContent={Security.get('batteryLevel')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.alarmState')} itemContent={Security.get('alarmState')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.notifications')} itemContent={Security.get('notifications')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.lastConnection')}
                        itemContent={this.renderLastConnection(Security.get('lastConnection'))}
                    />
                </Grid>
            </Grid>
        );
    };

    renderChildren = () => {
        const { loading } = this.state;
        const { Security } = this.props;
        return (
            <Fragment>
                <FHETitle title={Security.get('label')} Icon={SvgSecurity} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        Security.get('macAddress')
                                            ? Security.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.productType')}
                                    itemContent={Translator.translate(
                                        `general.products.Security.table.data.productType.${Security.get('productType')}`
                                    )}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={Security.get('userEmail')} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={Security.get('firmwareVersion')}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />

                    <FHEContainerForm loading={loading} onRender={this.renderPartDetail} />

                    <FHEDivider title={Translator.translate('general.Users')} />
                    {this.renderUserList()}
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSecurityDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');

    let Security = state.environments.myfhe.data.Security.getIn(['list', props.match.params.securityId], new Map());
    if (Security && users) {
        let otherUsers = [];
        let masterUser = new Map();
        if (Security.get('usersList')) {
            Security.get('usersList').forEach(userId => {
                users.find(user => {
                    if (userId === user.get('_id')) {
                        if (masterUser.size === 0 && Security.get('userMasterId') === user.get('_id')) {
                            masterUser = user;
                            otherUsers.unshift(user);
                        } else {
                            otherUsers.push(user);
                        }
                    }
                });
            });
            Security = Security.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
        }
    }
    return {
        profile: state.data.user,
        Security,
        initialized: state.environments.myfhe.data.Security.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    },
    noConnection: {
        color: theme.palette.colors.red500
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators({ getSecurityDetails, switchSecurityMaster, dissociateSecurityUser, dissociateSecurityUserAndSwitchMaster }, dispatch)
    )(withStyles(styles, { withTheme: true })(SecurityDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/Security/details.js